import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Snackbar } from "@mui/material";
import React, { Fragment } from "react";

type SnackerProps = {
  openToast?: boolean;
  handleCloseToast: () => void;
  selectedIds: any[];
  snackbarText: string;
  action: any;
};

const Snacker: React.FC<SnackerProps> = ({
  openToast,
  handleCloseToast,
  selectedIds,
  snackbarText,
  action,
}) => {
  const message =
    selectedIds.length > 0
      ? `${selectedIds.length} ${
          selectedIds.length > 1 ? `${snackbarText}s` : snackbarText
        } selected`
      : `No ${snackbarText} selected`;

  const defaultAction = (
    <Fragment>
      {action}
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseToast}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Fragment>
  );

  return (
    <Snackbar
      key={selectedIds.length}
      open={openToast}
      onClose={handleCloseToast}
      message={message}
      autoHideDuration={null}
      action={defaultAction}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    />
  );
};

export default Snacker;
